import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

import { CoacheeSettingsController } from './coachee-settings.controller';
import { CoacheeSettingsStore } from './coachee-settings.store';

@Component({
	selector: 'spr-coachee-settings',
	templateUrl: './coachee-settings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheeSettingsStore, CoacheeSettingsController],
	host: {
		class: 'relative block h-full',
	},
})
export class CoacheeSettingsComponent {
	constructor(
		private _translateService: TranslateService,
		public controller: CoacheeSettingsController,
		private _confirmationService: ConfirmationService
	) {}

	public onDisassociateClick() {
		this._confirmationService.confirm({
			message: this._translateService.instant(
				'presentation.app.page.settings.coachee.disassociate.confirmation'
			),
			acceptLabel: this._translateService.instant('presentation.primeng.yes'),
			rejectLabel: this._translateService.instant('presentation.primeng.no'),
			acceptButtonStyleClass: 'p-button-primary-transparent',
			accept: () => this.controller.disassociateCoach(),
		});
	}

	public onProductTourClick() {
		this.controller.triggerProductTour();
	}
}
